export function getTipoAnalistaLabel(ehSuporte, ehDesenvolvedor) {
    const s = !!(ehSuporte === 1 || ehSuporte === true);
    const d = !!(ehDesenvolvedor === 1 || ehDesenvolvedor === true);
    if (s && d) return 'Suporte, Desenvolvedor';
    if (s) return 'Suporte';
    if (d) return 'Desenvolvedor';
    return '';
}

export function getAnalistaDisplayNome(nome, opts = {}) {
    const { tipo_analista, eh_suporte, eh_desenvolvedor } = opts;
    let label = tipo_analista != null && String(tipo_analista).trim() !== '' ? String(tipo_analista).trim() : '';
    if (label === '') label = getTipoAnalistaLabel(eh_suporte, eh_desenvolvedor);
    const n = (nome != null && nome !== '') ? String(nome).trim() : '';
    return label ? `${n || 'Usuário'} (${label})` : (n || 'Usuário');
}
